/* eslint-disable security/detect-object-injection */
import './index.style.less'

import { DeleteOutlined, MenuOutlined } from '@ant-design/icons'
import { Form, Input } from 'antd'

import { SortableHandle } from 'react-sortable-hoc'

import { ColumnsType } from 'antd/es/table/interface'
import TextArea from 'antd/lib/input/TextArea'

const DragHandle = SortableHandle(() => (
  <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />
))

export interface DataType {
  key?: string
  index: number
  sort?: number
  code?: string
  pomDecription?: string
  plusTolerance?: number
  minusTolerance?: number
  size?: any
  field?: string
}

interface ColumnType {
  sizes: string[]
  handleRemovePOM: (key: string) => void
  key: string
  setFieldsValue: any
}

export function generateSizeColumn(props: ColumnType) {
  const { sizes, handleRemovePOM, key, setFieldsValue } = props
  const columns: ColumnsType<DataType> = [
    {
      dataIndex: 'sort',
      className: 'drag-invisible',
      fixed: 'left',
      width: 10,
      render: (_, data, index) => {
        const myKey = `${key}:index:${data.field}`
        setFieldsValue({ [myKey]: `${index}` })
        return <Form.Item hidden name={myKey} className="editable-form-order" />
      },
    },
    {
      title: '',
      dataIndex: 'sort',
      className: 'drag-visible',
      width: 50,
      fixed: 'left',
      render: () => <DragHandle />,
    },

    {
      title: 'Code',
      dataIndex: 'code',
      className: 'drag-visible',
      fixed: 'left',
      width: 130,
      render: (_, data) => (
        <Form.Item
          initialValue={data.code}
          name={`${key}:code:${data.field}`}
          className="editable-form-order"
        >
          <Input defaultValue={data.code} placeholder="Text" size="large" />
        </Form.Item>
      ),
    },
    {
      title: 'POM Description',
      dataIndex: 'pomDecription',
      className: 'drag-visible',
      width: 350,
      fixed: 'left',
      render: (_, data) => (
        <Form.Item
          name={`${key}:pomDecription:${data.field}`}
          className="editable-form-order"
          initialValue={data.pomDecription}
        >
          <TextArea
            defaultValue={data.pomDecription}
            placeholder="Text"
            size="large"
            rows={1}
          />
        </Form.Item>
      ),
    },
    {
      title: 'Tol(+)',
      dataIndex: 'plusTolerance',
      fixed: 'left',
      width: 100,
      render: (_, data) => (
        <Form.Item
          key={data.field}
          name={`${key}:plusTolerance:${data.field}`}
          className="editable-form-order"
          initialValue={data.plusTolerance}
        >
          <Input
            type="number"
            onWheel={(e: any) => e.target.blur()}
            defaultValue={data.plusTolerance}
            placeholder={'0'}
            size="large"
            className="measurement-input-number"
          />
        </Form.Item>
      ),
    },
    {
      title: 'Tol(-)',
      dataIndex: 'minusTolerance',
      fixed: 'left',
      width: 100,
      render: (_, data) => (
        <Form.Item
          key={data.field}
          name={`${key}:minusTolerance:${data.field}`}
          className="editable-form-order"
          initialValue={data.minusTolerance}
        >
          <Input
            type="number"
            onWheel={(e: any) => e.target.blur()}
            defaultValue={data.minusTolerance}
            placeholder={'0'}
            size="large"
            className="measurement-input-number"
          />
        </Form.Item>
      ),
    },
  ]
  // columns.push
  sizes.forEach((size) => {
    columns.push({
      title: size,
      dataIndex: size,
      width: 120,
      render: (_, data) => (
        <Form.Item
          key={data.field}
          name={`${key}:${size}:${data.field}`}
          className="editable-form-order"
          initialValue={data[size]}
        >
          <Input
            type="number"
            onWheel={(e: any) => e.target.blur()}
            defaultValue={data[size]}
            placeholder={'0'}
            size="large"
            className="measurement-input-number"
          />
        </Form.Item>
      ),
    })
  })
  columns.push({
    title: '',
    dataIndex: 'index',
    fixed: 'right',
    width: 50,
    render: (_, record) => (
      <DeleteOutlined onClick={() => handleRemovePOM(record.field)} />
    ),
  })
  return columns
}
